import { render } from "./Individual_Items.vue?vue&type=template&id=74ceb8b3&scoped=true"
const script = {}

import "./Individual_Items.vue?vue&type=style&index=0&id=74ceb8b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ceb8b3"]])

export default __exports__